<template>
  <!-- <div id="app"> -->
  <router-view />
  <!-- </div> -->
</template>

<script>
export default {
  name: 'App',
  components: {},
  // The onpopstate handler that used to live here has been removed. It bounced a
  // signed out visitor to /login from any path except /login itself, which meant
  // pressing Back on a public page - the landing page or the customer facing
  // /civilian/tracking - threw them at a sign-in form they do not need. Router
  // guards already run on back and forward navigations and already handle both
  // cases it was covering, using each route's own meta rather than a path
  // comparison, so there is nothing left for it to do.
};
</script>

<style lang="scss" scoped>
@import './App.scss';

.logo {
  width: 50px;
  height: 50px;
}
</style>
